export default {"src":"/_next/static/media/check.bfb5cb59.svg","height":24,"width":24};